import type {ReactElement} from 'react';
import React from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {Panel, PanelHeader} from '@Components/panel';
import {useUpdateEffect} from 'ahooks';
import {MediaSlideFiltersOptions} from '@Panels/poster-editor-item-filters-panel/components/media-slide-filters-options';
import {ItemFiltersOptions} from '@Panels/poster-editor-item-filters-panel/components/item-filters-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';

interface PosterEditorItemFiltersOptionProps {
  panelId: string;
}

export default function PosterEditorItemFiltersPanel({...props}: PosterEditorItemFiltersOptionProps): ReactElement | null {
  const onClose = useDefaultPanelClose(props.panelId);
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();

  useUpdateEffect((): void => {
    onClose();
  }, [activeItem]);

  useUpdateEffect((): void => {
    if (activeItem?.isSlideshow()) {
      onClose();
    }
  }, [activeSlideUID]);

  if (!activeItem) {
    return null;
  }

  const getHeader = (): ReactElement => {
    return <PanelHeader onClose={onClose} title={window.i18next.t('pmwjs_filters')} />;
  };

  const getContent = (): ReactElement => {
    if (activeItem.isSlideshow()) {
      return <MediaSlideFiltersOptions />;
    }

    return <ItemFiltersOptions />;
  };

  return <Panel panelHeader={getHeader()} panelContent={getContent()} />;
}
